import { StartMatch } from "./StartMatch.js";
import { BaseCounter } from "./BaseCounter.js";
import { CounterValue } from "./CounterValue.js";
import { SelectBase } from "./SelectBase.js";
import { BaseWin } from "./BaseWin.js";
import { BaseLose } from "./BaseLose.js";
import { BaseInitiative } from "./BaseInitiative.js";
import { BaseEpicAction } from "./BaseEpicAction.js";
import { BaseArea } from "./BaseArea.js";
import { MatchEnded } from "./MatchEnded.js";
import { SettingBar } from "./SettingBar.js";
import { SelectBaseModal } from "./SelectBaseModal.js";
import { PickWinnerModal } from "./PickWinnerModal.js";
import { BaseHeal } from "./BaseHeal.js";
import { BaseDamage } from "./BaseDamage.js";
import { GameTimer } from "./GameTimer.js";
import { SelectLeaderModal } from "./SelectLeaderModal";
import { PlayerLeader } from "./PlayerLeader";
import { LogModal } from "./LogModal";
import { InitiativeModal } from "./InitiativeModal";

export function RegisterComponents() {
  customElements.define("start-match", StartMatch);
  customElements.define("base-counter", BaseCounter);
  customElements.define("counter-value", CounterValue);
  customElements.define("base-win", BaseWin);
  customElements.define("base-lose", BaseLose);
  customElements.define("base-initiative", BaseInitiative);
  customElements.define("base-epic", BaseEpicAction);
  customElements.define("base-area", BaseArea);
  customElements.define("match-ended", MatchEnded);
  customElements.define("settings-bar", SettingBar);
  customElements.define("select-base", SelectBase);
  customElements.define("select-base-modal", SelectBaseModal);
  customElements.define("select-leader-modal", SelectLeaderModal);
  customElements.define("pick-winner-modal", PickWinnerModal);
  customElements.define("base-heal-animation", BaseHeal);
  customElements.define("player-leader", PlayerLeader);
  customElements.define("base-damage-animation", BaseDamage);
  customElements.define("game-timer", GameTimer);
  customElements.define("log-modal", LogModal);
  customElements.define("initiative-modal", InitiativeModal);
}
